import { MDBCard, MDBCardBody, MDBCollapse, MDBCollapseHeader } from "mdbreact";
import styles from "../../style.module.scss";
import React from "react";
import { uniqueId } from "lodash-es";

class CollapseCustom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseID: " "
    };
  }

  toggleCollapse = collapseID => {
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    }));

    console.log("e  ", collapseID);
  };

  render() {
    const { data } = this.props;
    const dataList = item => item?.serviceList || item?.drugList;
    return (
      <div>
        {data.map(item => {
          return (
            <MDBCard key={uniqueId()} className={styles.collapseContainer}>
              <MDBCollapseHeader
                className={
                  this.state.collapseID === `collapse${item.id}`
                    ? styles.collapseHeaderSelect
                    : styles.collapseHeader
                }
                onClick={() => this.toggleCollapse(`collapse${item.id}`)}
              >
                <p className={styles.GroupTitle}>
                  <span className={styles.title}>{item.name}</span>
                  <span className={styles.description}>
                    {item?.description}
                  </span>
                </p>
                <i
                  className={
                    this.state.collapseID === `collapse${item.id}`
                      ? "fa fa-angle-down"
                      : "fa fa-angle-right"
                  }
                />
              </MDBCollapseHeader>
              <MDBCollapse
                className={styles.collapseContent}
                id={`collapse${item.id}`}
                isOpen={this.state.collapseID}
              >
                <MDBCardBody className={styles.cardBody}>
                  <ul className={styles.listTypeVacxin}>
                    {dataList(item).map(item => {
                      return (
                        <li key={uniqueId()}>
                          <div className={styles.typeVacxin}>
                            <p>
                              <span className={styles.name}>{item?.name}</span>
                              <span className={styles.price}>
                                {item?.price}đ
                              </span>
                            </p>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </MDBCardBody>
              </MDBCollapse>
            </MDBCard>
          );
        })}
      </div>
    );
  }
}

export default CollapseCustom;
